import {Fragment} from "preact";
import {iconFooterNewsletter, iconFooterNewsletterButton} from "../../assets";
import s from "./newsletterForm.module.css";
import {Link} from "preact-router/match";
import {useNewsletterForm} from "./useNewsletterForm";
import { useAppContext } from "../../contexts";

const NewsletterForm = props => {
    // Destructured props
    const {
        isModal = false,
        setIsOpen = () => {}
    } = props;

    // Component logic data
    const componentProps = useNewsletterForm({
        setIsOpen
    });

    // Destructured component logic data
    const {
        formValues,
        errors,
        isLoading,
        handleChange,
        handleSubmit
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={`w-full flex flex-col items-center justify-center ${(!isModal && "pt-4")}`}>
                <img
                    src={iconFooterNewsletter}
                    alt={"Newsletter icon"}
                    className={`${s.newsletterImage} ${highContrast ? " highImage " : ""}`}
                    data-testid="newsletter-footer-img"
                />
                <h3 className={s.heading} data-testid="newsletter-footer-title">
                    Sua saúde é a nossa prioridade
                </h3>
                <h3 className={s.paragraph} data-testid="newsletter-footer-paragraph">
                    Assine o nosso boletim informativo e receba ofertas, dicas de saúde e muito mais.
                </h3>
            </div>
            <form
                className={(!isModal ? s.form : "flex flex-col w-full mx-auto my-5 gap-4")}
                onSubmit={e => handleSubmit(e)}
                data-testid="newsletter-footer-form"
            >
                <fieldset className={`flex flex-col gap-y-1 justify-start w-full ${(!isModal && "md:w-2/3")}`}>
                    <input
                        type={"text"}
                        placeholder={"Seu nome"}
                        name={"name"}
                        id={"name-input"}
                        className={s.input + (errors.name ? ` ${s.isInvalid}` : !errors.name && formValues.name ? ` ${s.isValid}` : "")}
                        value={formValues.name}
                        onInput={e => handleChange(e)}
                        data-testid="newsletter-footer-form-name"
                    />
                    {errors.name && (
                        <p className={"text-sm text-sabin-red-default font-bold"}>
                            {errors.name}
                        </p>
                    )}
                </fieldset>
                <div className={"flex flex-row justify-between w-full gap-x-4"}>
                    <fieldset className={"w-full flex flex-col gap-y-1 justify-start"}>
                        <input
                            type={"email"}
                            placeholder={"Seu melhor email"}
                            name={"email"}
                            id={"email-input"}
                            className={s.input + (errors.email ? ` ${s.isInvalid}` : !errors.email && formValues.email ? ` ${s.isValid}` : "")}
                            value={formValues.email}
                            onInput={e => handleChange(e)}
                            data-testid="newsletter-footer-form-email"
                        />
                        {errors.email && (
                            <p className={"text-sm text-sabin-red-default font-bold"}>
                                {errors.email}
                            </p>
                        )}
                    </fieldset>
                    <button
                        type={"submit"}
                        className={`
                            ${s.submitButton} 
                            ${isLoading ? " opacity-50" : ""}
                            ${highContrast ? "highFormButton" : ""}
                        `}
                        disabled={isLoading}
                        data-testid="newsletter-footer-form-button"
                    >
                        Assinar
                        <img
                            src={iconFooterNewsletterButton}
                            alt={"Newsletter submit button icon"}
                            data-testid="newsletter-footer-form-button-img"
                            className={`${highContrast ? "highImage" : ""}`}
                        />
                    </button>
                </div>
            </form>
            <p
                className={`${s.privacyPolicy} ${(!isModal && "pb-12")}`}
                data-testid="newsletter-footer-form-term"
            >
                Ao se cadastrar você concorda em receber nossos e-mails conforme a nossa
                <Link href={"/politica-de-privacidade"} className={"pl-[0.2rem] underline"} data-testid="newsletter-footer-form-term-link">
                    política de privacidade
                </Link>
            </p>
        </Fragment>
    )
}

export default NewsletterForm;
